
import apiDueDate from '../services/apiDueDate'

const state = {
  dueDate: {
    expired: '0',
    expireToday: '0',
    expireTomorrow: '0',
    expireNext: '0',
    expireWithout: '0',
    done: '0',
    total: '0',
    nameDepartment: ''
  },
  tasks: false,
  expire: false

}

const getters = {
  dueDate: (state) => state.dueDate,
  tasks: (state) => state.tasks,
  expire: (state) => state.expire

}

const actions = {
  async setDueDate ({ commit, getters }, boardId) {
    await apiDueDate.getDuedate(boardId)
      .then(payload => commit('INITIAL_STATE', payload.data))
      .catch(err => {
        this.$errorFormated(err.response)
        throw err
      })
  },

  setShowDashs ({ commit }, { tasks, dueDate }) {
    commit('SET_DASHS', { tasks: tasks, dueDate: dueDate })
  }

}

const mutations = {

  INITIAL_STATE (state, data) {
    state.dueDate = {
      expired: data.expired,
      expireToday: data.expireToday,
      expireTomorrow: data.expireTomorrow,
      expireNext: data.expireNext,
      expireWithout: data.expireWithout,
      done: data.done,
      total: data.total,
      nameDepartment: data.titleDepartment
    }
  },

  SET_DASHS (state, { tasks, dueDate }) {
    state.tasks = tasks
    state.expire = dueDate
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
